<template>
    <AuthStepBasicDialog :errorMessage="state.errorMessage">




        <template #icon>
            <EmailIcon></EmailIcon>
        </template>



        <template #title>
            Verifying your link!
        </template>




        <template #form>
            <v-progress-circular color="primary" indeterminate v-if="state.loading" ></v-progress-circular>
        </template>





    </AuthStepBasicDialog>
</template>










<script setup>

import authEvents from '@/Events/AuthDialog';
import EmailIcon from '@/icons/ResetPassword/Email.vue';
import { provide, ref, onUnmounted, onMounted, reactive } from 'vue';
import { ForgotPasswordService } from '@/api/services/ForgotPasswordService';
import AuthStepBasicDialog from '@/components/Auth/Common/Auth-Steps-Basic-Dialog.vue';




// control dialog visibility
const dialogVisible = ref(false);
provide('openDialog', dialogVisible);

const state = reactive({
    errorMessage: '',
    verificationCode: '',
    loading: true,
});








const verifyVerificationCode = async () => {

    try {
        const verificationCodeVerified = await ForgotPasswordService.verifyVerificationCode(state.verificationCode);
        if (verificationCodeVerified) {
            authEvents.emit('signup-verification-email-verified');
            closeVerificationLinkSentDialog();
        } else {
            state.errorMessage = 'Incorrect Verification link. Please try again.';
        }
    } catch (error) {
        state.errorMessage = error.friendly_message || 'Failed to verify verification link. Please try again.';
    } finally {
        state.loading = false;
    }

};







const signupVerificationLinkReceived = async (verificationCode) => {
    openVerificationLinkSentDialog();
    state.verificationCode = verificationCode;
    verifyVerificationCode();
};







const openVerificationLinkSentDialog = () => {
    dialogVisible.value = true;
};

const closeVerificationLinkSentDialog = () => {
    dialogVisible.value = false;
};







// listen for events
onMounted(() => {
    authEvents.on('signup-verification-email-link-received', signupVerificationLinkReceived);
});
// remove event listener and clear interval
onUnmounted(() => {
    authEvents.off('signup-verification-email-link-received', signupVerificationLinkReceived);
});

</script>